<div class="tt-o-menu">
  <tt-button ref="menuTrigger" :type="triggerType" :class="triggerClass" :aria-label="tiggerAriaLabel" @click="menuTriggerSelected" :aria-expanded="isMenuExpanded" aria-haspopup="menu"><slot name="triggerContent"></slot></tt-button>
  <slot></slot>
</div>
